import { Controller } from "@hotwired/stimulus";
import { i18n } from "../utils/i18n";

export default class extends Controller {
  static targets = [
    "footerBar",
    "selectedCount",
    "selectedText",
    "deleteMultipeButton",
    "selectAllCheckbox",
    "checkbox"
  ];

  static values = {
    modelName: String
  };

  selectedItems = [];

  connect() {
    if (this.hasFooterBarTarget) {
      this.footerBarTarget.classList.add("hidden");
    }
    const itemIds = this.checkboxTargets
      .filter(({ checked }) => checked)
      .map(({ value }) => value);
    this.setSelectedItems(itemIds);
  }

  toggleSelection({ target: { value: itemId, checked } }) {
    this.setSelectedItems(
      checked
        ? [...this.selectedItems, itemId]
        : this.selectedItems.filter((id) => id !== itemId)
    );
  }

  setSelectedItems(items) {
    if (!this.hasSelectAllCheckboxTarget) {
      return;
    }

    this.selectedItems = items;

    if (this.selectedItems.length === 0) {
      this.selectAllCheckboxTarget.removeAttribute("partial");
      this.selectAllCheckboxTarget.checked = false;
    } else if (items.length === this.checkboxTargets.length) {
      this.selectAllCheckboxTarget.removeAttribute("partial");
      this.selectAllCheckboxTarget.checked = true;
    } else {
      this.selectAllCheckboxTarget.setAttribute("partial", true);
      this.selectAllCheckboxTarget.checked = true;
    }

    const modelName = i18n.t(this.modelNameValue, {
      scope: "activerecord.models",
      count: this.selectedItems.length
    });

    const text = i18n.t("selected", {
      scope: `list_table.${this.modelNameValue}`,
      count: this.selectedItems.length,
      model_name: modelName,
      defaultValue: i18n.t("selected", { scope: "list_table" })
    });

    this.selectedCountTarget.innerHTML = `${this.selectedItems.length}`;
    this.selectedTextTarget.innerHTML = text;

    this.deleteMultipeButtonTarget.dataset[
      "modals-ConfirmDeleteMultipleSelectedItemsValue"
    ] = JSON.stringify(this.selectedItems);
    this.deleteMultipeButtonTarget.dataset[
      "modals-ConfirmDeleteMultipleModelNameValue"
    ] = this.modelNameValue;

    if (this.hasFooterBarTarget) {
      if (this.selectedItems.length > 0) {
        this.footerBarTarget.classList.remove("hidden");
      } else {
        this.footerBarTarget.classList.add("hidden");
      }
    }
  }

  // Selects all if none is selected, otherwise unselect any selected items
  toggleSelectedItems() {
    if (this.selectedItems.length > 0) {
      this.unselectAll();
    } else {
      this.selectAll();
    }
  }

  unselectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.setSelectedItems([]);
  }

  selectAll() {
    const itemIds = this.checkboxTargets.map(({ value }) => value);
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true;
    });
    this.setSelectedItems(itemIds);
  }
}
